import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const useExerciseMuscles = () => {
  const { t } = useTranslation();
  const [levels, setLevels] = useState();
  const defaultValues = [
    { label: t('EXERCISE.abs'), value: 'Abs' },
    { label: t('EXERCISE.arms'), value: 'Arms' },
    { label: t('EXERCISE.back'), value: 'Back' },
    { label: t('EXERCISE.chest'), value: 'Chest' },
    { label: t('EXERCISE.legs'), value: 'Legs' },
    { label: t('EXERCISE.shoulders'), value: 'Shoulders' },
    { label: t('EXERCISE.multiArea'), value: 'Multi-area' },
  ];
  if (!levels) {
    setLevels(defaultValues);
  }
  return levels;
};

export default useExerciseMuscles;
